import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";

export const getCurrentUser = () => {
  const token = getJwtFromCookies();
  return token ? jwtDecode(token) : null;
};

const getJwtFromCookies = () => {
  let cookieName = process.env.DEFAULT_COOKIE_NAME || "rankmi_jwt";
  return getCookie(cookieName);
};

const getCookie = (cname) => {
  return Cookies.get(cname);
};

export const getValueFromJwt = (key) => {
  try {
    const jwt = jwtDecode(getJwtFromCookies());
    return jwt[key];
  } catch (error) {
    console.error(error);
    return null;
  }
};
